import React from 'react';
import { Input, Icon } from '@chakra-ui/react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { InputGroup } from '@/components/ui/input-group';

interface Props {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
}

const Search: React.FC<Props> = ({
  searchQuery,
  onSearchChange,
  onClearSearch,
}) => {
  return (
    <InputGroup
      w={'full'}
      startElement={<Icon as={MagnifyingGlassIcon} w={4} h={4} />}
      endElement={<Icon as={XMarkIcon} w={4} h={4} onClick={onClearSearch} />}
    >
      <Input
        placeholder={'Search ...'}
        value={searchQuery}
        onChange={onSearchChange}
      />
    </InputGroup>
  );
};

export default Search;
